import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import UslugePage from './pages/UslugePage';
import ONamaPage from './pages/ONamaPage';
import ProjektiPage from './pages/ProjektiPage';
import GalerijaPage from './pages/GalerijaPage';
import KontaktPage from './pages/KontaktPage';

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/usluge" element={<UslugePage />} />
          <Route path="/o-nama" element={<ONamaPage />} />
          <Route path="/projekti" element={<ProjektiPage />} />
          <Route path="/projekti/u-toku/:projectSlug" element={<GalerijaPage />} />
          <Route path="/projekti/u-toku" element={<GalerijaPage />} />
          <Route path="/projekti/zavrseni" element={<GalerijaPage />} />
          <Route path="/galerija" element={<Navigate to="/projekti" replace />} />
          <Route path="/kontakt" element={<KontaktPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
